<script>
import { mapState, mapActions } from "vuex";
import { VueGoodTable } from "vue-good-table";
import APIService from "@/services/api.service";
import axios from "axios";
import config from "@/data/config";
import { SweetModal } from "sweet-modal-vue";

export default {
	name: "keluargaKatolikData",
	components: {
		VueGoodTable,
		SweetModal,
	},
	data() {
		return {
			info: {},
			loading: true,
			PDFloading: false,
			frameLoading: false,
			baseURL: config.baseURL,
			windowHeight: window.innerHeight - 250,
			fileURL: "",
			item: {
				id: "",
				uid: "",
				nomor: "",
				nama_kepala: "",
				anggota: "",
				alamat: "",
			},
			columns: [
				{
					label: "Nomor",
					field: "nomor",
					sortable: false,
				},
				// {
				// 	label: "Kepala Keluarga",
				// 	field: "nama_kepala",
				// 	sortable: false,
				// },
				{
					label: "Kepala Keluarga",
					field: this.namaFn,
					sortable: false,
					thClass: "text-center",
               html: true
				},
				{
					label: "Anggota",
					field: "total",
					sortable: false,
				},
				{
					label: "Stasi/Lingkungan",
					field: "lingkungan_stasi",
					sortable: false,
					filterOptions: {
						enabled: true,
						placeholder: "Semua",
						filterDropdownItems: [
							"AGUSTINUS",
                     "AMBROSIUS",
                     "ANDREAS",
                     "ANGELA MERICI",
                     "BERNADETA",
                     "BERNADUS",
                     "BUNDA MARIA",
                     "ELISABET",
                     "FRANSISKUS ASISI",
                     "JERORA I BUNDA MARIA",
                     "JERORA I YOHANES PAULUS II",
                     "JERORA I YOSEF",
                     "JERORA II MARKUS",
                     "JERORA II MATIUS",
                     "JERORA II PETRUS",
                     "LUKAS",
                     "LUSIA",
                     "PAULUS",
                     "THERESIA",
                     "THOMAS RASUL",
                     "YAKOBUS",
                     "YOHANES DON BOSCO",
                     "YOHANES",
                     "YOSEF",
						],
						trigger: "enter",
					},
				},
				{
					label: "Alamat",
					field: "alamat",
					sortable: false,
				},
			],
			rows: [],
			totalRecords: 0,
			serverParams: {
				columnFilters: {},
				sort: {
					field: "",
					type: "",
				},
				search: "",
				page: 1,
				perPage: 20,
			},
		};
	},
	mounted() {
		this.loadItems();
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			auth: (state) => state.auth.user,
			// rows: (state) => state.keluargaKatolik.data,
			// totalRecords: (state) => state.keluargaKatolik.totalRecords,
		}),
	},
	watch: {
		PDFloading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	methods: {
		...mapActions({
			getAll: "keluargaKatolik/getAllRemote",
			delete: "keluargaKatolik/delete",
		}),
		namaFn(row) {
			const nama = row.kepala_keluarga ? "<span>"+row.kepala_keluarga+"</span>" : "<span class='text-danger'>"+row.nama_kepala+"</span>";

			return nama;
		},
		refreshData() {
			this.updateParams({
				perPage: 20,
				page: 1,
				search: { searchTerm: "" },
			});
			this.$refs["goodTable"].reset();
			this.loadItems();
		},
		tambahData() {
			this.$router.push("/keluarga_katolik/add");
		},
		getInfo() {
			this.info = this.$store.getters["keluargaKatolik/getById"](
				this.item.id
			);
			this.$bvModal.show("modal-info");
		},
		setEdit() {
			this.$router.push("/keluarga_katolik/edit/" + this.item.uid);
		},
		swalConfirm() {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Ya, Hapus!",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					return this.delete(this.item.uid).then(
						(response) => {
							return Promise.resolve(response.data);
						},
						(error) => {
							this.$swal("Gagal!", "", "danger");
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== "undefined") {
					if (result.value) {
						this.loadItems();
						this.$bvModal.hide("modal-action");
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
		showPDFKK() {
			console.log("START");
			this.PDFloading = true;
			this.frameLoading = true;
			this.fileURL = this.baseURL + "assets/_blank.pdf";
			axios
				.post(APIService.getPDFKK(), this.item, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
                  const timestamp = this.$moment().toDate().getTime()
                  
						this.fileURL =
							this.baseURL + "pdf/" + response.data.filename + ".pdf?v=" + timestamp;
						this.$refs.modalfile.open();
						this.PDFloading = false;
						console.log("FINISH");
					},
					() => {
						// this.PDFloading = false;
					}
				);
		},
		load() {
			this.frameLoading = false;
			console.log("FINISH LOAD");
		},

		// --------------------
		// ---- GOOD TABLE ----
		// --------------------
		async loadItems() {
			this.loading = true;
			await this.getAll(this.serverParams).then((response) => {
				// console.log(response);
				this.rows = response.rows;
				this.totalRecords = response.totalRecords;
			});
		},
		updateParams(newProps) {
         
			this.serverParams = Object.assign({}, this.serverParams, newProps);
		},
		onPageChange(params) {
         console.log(params);
			this.updateParams({ page: params.currentPage });
			this.loadItems();
		},
		onPerPageChange(params) {
			this.updateParams({ perPage: params.currentPerPage });
			this.loadItems();
		},
		onSortChange(params) {
			this.updateParams({
				sort: [
					{
						type: params.sortType,
						field: this.columns[params.columnIndex].field,
					},
				],
			});
			this.loadItems();
		},
		onColumnFilter(params) {
			this.updateParams(params);
			this.loadItems();
		},
		onRowClick(params) {
			this.item.id = params.row.id;
			this.item.uid = params.row.uid;
			this.item.nomor = params.row.nomor;
			this.item.nama_kepala = params.row.nama_kepala;
			this.item.alamat = params.row.alamat;
			this.item.anggota = params.row.total;
			this.$bvModal.show("modal-action");
		},
		onSearch(params) {
			if (params.searchTerm) {
				this.serverParams.search = params;
				this.loadItems();
			}
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Data Keluarga Katolik" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh & Reset"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
                           <!-- BYPASS TAMBAH UMAT UNTUK AKUN LINGKUNGAN -->
									<b-button
										variant="primary"
										size="sm"
										@click="tambahData()"
										v-b-tooltip.hover
										title="Tambah"
										><i class="fa fa-plus"></i> Tambah</b-button
									>									
                           <!-- <b-button
										v-show="this.auth.group_id != '3'"
										variant="primary"
										size="sm"
										@click="tambahData()"
										v-b-tooltip.hover
										title="Tambah"
										><i class="fa fa-plus"></i> Tambah</b-button
									> -->
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<vue-good-table
						mode="remote"
						ref="goodTable"
						@on-page-change="onPageChange"
						@on-sort-change="onSortChange"
						@on-column-filter="onColumnFilter"
						@on-per-page-change="onPerPageChange"
						@on-row-click="onRowClick"
						@on-search="onSearch"
						:totalRows="totalRecords"
						:isLoading.sync="loading"
						:pagination-options="{
							enabled: true,
							dropdownAllowAll: false,
							setCurrentPage: 1,
							perPage: 20,
							ofLabel: 'dari',
                     perPageDropdown: [20, 50, 100],
						}"
						:rows="rows"
						:columns="columns"
						:search-options="{
							enabled: true,
							trigger: 'enter',
						}"
						:line-numbers="true"
					/>
				</div>
			</div>
		</div>

		<b-modal id="modal-action" centered title="Action" hide-footer>
			<div class="card">
				<div class="card-body card-action">
					<div class="collection-filter-block">
						<ul>
							<li>
								<div class="media">
									<feather type="book-open"></feather>
									<div class="media-body">
										<h5>Nomor</h5>
										<p>{{ item.nomor }}</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<feather type="user"></feather>
									<div class="media-body">
										<h5>Nama</h5>
										<p>{{ item.nama_kepala }}</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<feather type="users"></feather>
									<div class="media-body">
										<h5>Anggota</h5>
										<p>{{ item.anggota }}</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<feather type="map-pin"></feather>
									<div class="media-body">
										<h5>Alamat</h5>
										<p>{{ item.alamat }}</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<!-- silde-bar colleps block end here-->
			</div>
			<div class="text-center">
				<b-btn-group class="btn-group-pill text-center">
					<div
						class="btn-download btn btn-gradient f-w-500"
						@click="getInfo()"
					>
						<i class="fa fa-info"></i><br />Informasi
					</div>
					<div
                  v-if="this.auth.group_id != '3'"
						class="btn-download btn btn-gradient f-w-500"
						@click="showPDFKK()"
					>
						<i class="fa fa-file-pdf-o"></i><br />Cetak
					</div>
               <!-- BYPASS TAMBAH UMAT UNTUK AKUN LINGKUNGAN -->
					<div
						class="btn-download btn btn-gradient f-w-500"
						@click="setEdit()"
					>
						<i class="fa fa-edit"></i><br />Edit
					</div>					
               <!-- <div
						v-show="this.auth.group_id != '3'"
						class="btn-download btn btn-gradient f-w-500"
						@click="setEdit()"
					>
						<i class="fa fa-edit"></i><br />Edit
					</div> -->
					<div
						v-if="this.auth.group_id != '3'"
						class="btn-download btn btn-gradient-danger f-w-500"
						@click="swalConfirm()"
					>
						<i class="fa fa-times"></i><br />Delete
					</div>
				</b-btn-group>
			</div>
		</b-modal>

		<b-modal
			id="modal-info"
			hide-footer
			size="lg"
			title="Informasi Data Keluarga Katolik"
		>
			<div class="card shadow">
				<div class="card-body">
					<table class="table table-striped table-hover">
						<tbody></tbody>
						<tbody>
							<tr>
								<td>Nomor</td>
								<td>:</td>
								<td>{{ info.nomor }}</td>
							</tr>
							<tr>
								<td>Kepala Keluarga</td>
								<td>:</td>
								<td>{{ info.nama_kepala }}</td>
							</tr>
							<tr>
								<td>Paroki</td>
								<td>:</td>
								<td>{{ info.paroki }}</td>
							</tr>
							<tr>
								<td>Lingkungan Stasi</td>
								<td>:</td>
								<td>{{ info.lingkungan_stasi }}</td>
							</tr>
							<tr>
								<td>Kota/Kabupaten</td>
								<td>:</td>
								<td>{{ info.kabupaten }}</td>
							</tr>
							<tr>
								<td>Kecamatan</td>
								<td>:</td>
								<td>{{ info.kabupaten }}</td>
							</tr>
							<tr>
								<td>Kelurahan/Desa</td>
								<td>:</td>
								<td>{{ info.desa }}</td>
							</tr>
							<tr>
								<td>Alamat</td>
								<td>:</td>
								<td>{{ info.alamat }}</td>
							</tr>
							<tr>
								<td>Jumlah Anggota</td>
								<td>:</td>
								<td>{{ info.total }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</b-modal>

		<sweet-modal
			modal-theme="light"
			overlay-theme="dark"
			width="80%"
			ref="modalfile"
		>
			<div class="loader-box" v-show="frameLoading">
				<div class="loader-2"></div>
			</div>
			<iframe
				v-show="!frameLoading"
				width="100%"
				:height="windowHeight"
				:src="fileURL"
				frameborder="0"
				allowfullscreen
				@load="load()"
			></iframe>
		</sweet-modal>
	</div>
</template>

<style scoped>
.card-action {
	padding: 10px !important;
}
.btn-gradient-danger {
	color: #fff !important;
	font-weight: 500;
	padding: 10px 30px;
	border-radius: 5px;
	background: linear-gradient(26deg, #ff2828 0%, #ff7878 100%);
	letter-spacing: 0.06rem;
}
.btn-gradient-danger:hover {
	background: linear-gradient(26deg, #ff0000 0%, #ff4e4e 100%);
}
.btn-gradient:hover {
	background: linear-gradient(26deg, var(--theme-deafult) 0%, #7b29ff 100%);
}
</style>